/*
 * Author M. Atoar Rahman
 * Title: Drug Supplier
 * Description: Page for Drug Supplier
 * Date: 15/03/2022
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { SupplierProvider } from '../masterSetup/supplier/ContextAPI';
import DataTable from '../masterSetup/supplier/DataTable';
import FormInfo from '../masterSetup/supplier/FormInfo';
import PermissionDenied from './PermissionDenied';

export default function DrugSupplier() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['drug-supplier']) return <PermissionDenied />;

    return (
        <SupplierProvider>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Drug Supplier</h3>
                    <div>
                        <FormInfo />
                    </div>
                </Card.Header>
                <Card.Body>
                    <DataTable />
                </Card.Body>
            </Card>
        </SupplierProvider>
    );
}
